import { motion } from "framer-motion";
import { Zap, X, Headphones, ChevronRight } from "lucide-react";

const OPTIONS = [
  { id: "subscribe", label: "Assinar por R$ 25,00 mensais", sub: "Fale com a Bia agora", Icon: Zap, cls: "lz-opt lz-opt-main" },
  { id: "decline", label: "Não quero assinar", sub: "Agora não, obrigado", Icon: X, cls: "lz-opt" },
  { id: "support", label: "Já sou cliente", sub: "Falar com o suporte", Icon: Headphones, cls: "lz-opt" },
];

export const Choices = ({ onPick, disabled }) => (
  <motion.div data-testid="choices-panel" className="lz-choices"
    initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }}
    transition={{ type: "spring", stiffness: 260, damping: 30 }}>
    <p className="lz-choices-label">Toque em uma opção</p>
    {OPTIONS.map(({ id, label, sub, Icon, cls }, i) => (
      <motion.button key={id} data-testid={`choice-${id}-button`} className={cls} disabled={disabled}
        onClick={() => onPick(id)} whileTap={{ scale: 0.97 }}
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.12 + i * 0.07 }}>
        <span className="lz-opt-icon"><Icon size={18} /></span>
        <span className="flex-1 text-left">
          <span className="block text-[15px] font-semibold leading-tight">{label}</span>
          <span className="block text-[12.5px] opacity-75 mt-0.5">{sub}</span>
        </span>
        <ChevronRight size={18} className="opacity-70" />
      </motion.button>
    ))}
  </motion.div>
);
